"use client"
 
import { LeaveSummaryPage } from "../../../modules/leave-management/leave-summary"

interface LeaveSummaryProps {
  sidebarOpen?: boolean
}

export default function LeaveSummary({sidebarOpen }: LeaveSummaryProps) {
  return <LeaveSummaryPage />
}

